import { handshake } from '@/api/api'
import { useRequest } from 'ahooks'
import React from 'react'

const useHandshake = () => {
  const { runAsync: fetchHandshake, loading: handshakeLoading } = useRequest(
    handshake,
    {
      manual: true,
      onSuccess(data: any) {
      },
      onError(error: any) {},
    },
  )

  const getHandshake = ({tile}: any) => {
    fetchHandshake({ tileId: tile?.id }).then((data) => {
      const tileUrl = tile?.url || ''
        const separator = tileUrl.includes('?') ? '&' : '?'
        const newUrl = `${tileUrl}${separator}${data}`
        window.location.href = newUrl
    })
  }

  return { handshakeLoading, getHandshake }
}

export default useHandshake
